import { declareParams, concurrency } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createBaseQuery } from '../clients';
import { getResultResponseSchema } from '../types';

export const createGetResultQuery = () => {
	const query = createBaseQuery({
		params: declareParams<string>(),
		request: {
			method: 'GET',
			url: (token) => `/result/${token}`,
		},
		response: {
			contract: zodContract(getResultResponseSchema),
		},
	});

	concurrency(query, { strategy: 'TAKE_LATEST' });

	return query;
};
